// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDDJFJhXftU8KFX5o0-H6dqTK0AsbCZ3r4",
  authDomain: "mickeyssubs.firebaseapp.com",
  projectId: "mickeyssubs",
  storageBucket: "mickeyssubs.firebasestorage.app",
  messagingSenderId: "427701948109",
  appId: "1:427701948109:web:2d17051b7c77a704d3e384",
  measurementId: "G-DZ0FK0XH41"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);

export { app, analytics, db };